import React from 'react';
import { NavLink } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import { FaChartPie, FaBoxOpen, FaFileImport, FaDiceFive } from 'react-icons/fa';

const LINKS = [
  { to: '/csgo/overview', label: "Vue d'ensemble", icon: FaChartPie },
  { to: '/csgo/items', label: 'Items', icon: FaBoxOpen },
  { to: '/csgo/imports', label: 'Imports', icon: FaFileImport },
  { to: '/csgo/gambling', label: 'Gambling', icon: FaDiceFive }
];

function CsgoNav() {
  const linkClass =
    'd-flex align-items-center rounded-2 py-2 px-3 mb-1 text-decoration-none transition-all';
  const activeStyle = {
    backgroundColor: 'var(--color-background)',
    color: 'var(--color-accent)',
    fontWeight: '600'
  };
  const inactiveStyle = { color: 'var(--color-secondary)' };

  return (
    <Nav className="flex-column">
      {LINKS.map(({ to, label, icon: Icon }) => (
        <Nav.Item key={to}>
          <Nav.Link
            as={NavLink}
            to={to}
            className={linkClass}
            style={({ isActive }) => (isActive ? activeStyle : inactiveStyle)}
          >
            <Icon className="me-2" size={14} /> {label}
          </Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
}
export default CsgoNav;
